import type { AddMyFilesToRequestBody } from "@nlc/shared-types";

import authenticatedApi from "@/lib/api/client";

export function addMyFilesToRequest(
  requestId: number,
  body: AddMyFilesToRequestBody,
): Promise<Response> {
  return authenticatedApi
    .url(`/requests/${requestId}/my-files`)
    .post(body)
    .res();
}
